export var SEARCH_WIDTH_WITH_CATEGORY_MENU = '25.6rem';